import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../config';

export const useAppTranslate: () => (...args: Parameters<ReturnType<typeof useTranslation>['t']>) => string = () => {
  const { businessContext } = useContext(AppContext);
  const { t } = useTranslation(businessContext?.translateNamespace || 'common');

  return (...args) => t(...args);
};
